import React, { useEffect } from "react";
import LegalLayout from "./LegalLayout";
import { useLanguage } from "../../i18n/LanguageContext";

const AGBPage = () => {
  const { t } = useLanguage();
  useEffect(() => {
    document.title = `${t("legal.agb.title")} - Reflecta`;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", t("legal.agb.metaDescription"));
  }, [t]);

  return (
    <LegalLayout title={t("legal.agb.title")}>
      <p>
        Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für die Nutzung
        der Webanwendung Reflecta, betrieben von der Elaspix
        Unternehmergesellschaft (haftungsbeschränkt), Schliffkopfstraße 25,
        68163 Mannheim (nachfolgend „Anbieter").
      </p>

      <h2 className="text-xl font-semibold mt-8">1. Geltungsbereich</h2>
      <p>
        Diese AGB gelten für alle Nutzerinnen und Nutzer, die sich auf
        reflecta-ai.de registrieren oder die Anwendung nutzen. Mit der
        Registrierung erkennt der Nutzer diese AGB an. Entgegenstehende
        Bedingungen des Nutzers werden nicht anerkannt.
      </p>

      <h2 className="text-xl font-semibold mt-8">2. Leistungsbeschreibung</h2>
      <p>
        Reflecta ist eine KI-gestützte Journaling-Anwendung. Der Anbieter
        stellt folgende Funktionen bereit:
      </p>
      <ul className="list-disc ml-6 mt-2 space-y-1">
        <li>Erstellung und Verwaltung persönlicher Tagebucheinträge</li>
        <li>KI-gestützte Auswertung von Stimmungen und Aktivitäten</li>
        <li>Zielverfolgung und -analyse</li>
        <li>KI-Chat-Assistent</li>
        <li>Kalender- und Analyseansichten</li>
      </ul>
      <p className="mt-3">
        Reflecta befindet sich in der Entwicklung und wird als
        Demonstrationsanwendung betrieben. Der Anbieter behält sich vor,
        Funktionen jederzeit zu ändern, einzuschränken oder einzustellen.
      </p>

      <h2 className="text-xl font-semibold mt-8">3. Registrierung und Konto</h2>
      <p>
        Die Nutzung von Reflecta setzt eine Registrierung mit einer gültigen
        E-Mail-Adresse und einem Passwort voraus. Der Nutzer ist verpflichtet,
        seine Zugangsdaten vertraulich zu behandeln und den Anbieter
        unverzüglich zu informieren, wenn ein Missbrauch des Kontos vermutet
        wird. Es ist nicht gestattet, Konten an Dritte zu übertragen.
      </p>

      <h2 className="text-xl font-semibold mt-8">4. Kostenlose und kostenpflichtige Nutzung</h2>
      <p>
        Reflecta wird derzeit ausschließlich zu Demonstrations- und
        Testzwecken betrieben. Es werden keine kostenpflichtigen Verträge
        geschlossen und keine Zahlungen verarbeitet. Etwaige in der
        Benutzeroberfläche dargestellte Premium-Funktionen oder Preisangaben
        sind fiktiver Natur und begründen kein Vertragsverhältnis.
      </p>

      <h2 className="text-xl font-semibold mt-8">5. Nutzerpflichten</h2>
      <p>Der Nutzer verpflichtet sich:</p>
      <ul className="list-disc ml-6 mt-2 space-y-1">
        <li>keine rechtswidrigen Inhalte einzugeben oder zu verbreiten,</li>
        <li>
          die Anwendung nicht zu missbrauchen, insbesondere keine automatisierten
          Massenanfragen zu stellen,
        </li>
        <li>
          keine Maßnahmen zu ergreifen, die die Infrastruktur des Anbieters
          gefährden könnten.
        </li>
      </ul>
      <p className="mt-3">
        Der Anbieter behält sich vor, Konten bei Verstößen ohne Vorankündigung
        zu sperren oder zu löschen.
      </p>

      <h2 className="text-xl font-semibold mt-8">6. Verfügbarkeit</h2>
      <p>
        Der Anbieter strebt eine hohe Verfügbarkeit der Anwendung an, übernimmt
        jedoch keine Garantie für ununterbrochenen Betrieb. Wartungsarbeiten,
        technische Störungen oder höhere Gewalt können zu vorübergehenden
        Unterbrechungen führen. Ein Anspruch auf Verfügbarkeit besteht nicht.
      </p>

      <h2 className="text-xl font-semibold mt-8">7. Haftung</h2>
      <p>
        Der Anbieter haftet unbeschränkt für Schäden aus der Verletzung des
        Lebens, des Körpers oder der Gesundheit sowie für vorsätzliches oder
        grob fahrlässiges Handeln. Im Übrigen ist die Haftung auf
        vorhersehbare, vertragstypische Schäden beschränkt. Eine Haftung für
        den Verlust von Daten besteht nur, soweit dieser durch zumutbare
        Datensicherungsmaßnahmen nicht verhindert werden konnte.
      </p>

      <h2 className="text-xl font-semibold mt-8">8. Datenschutz</h2>
      <p>
        Die Verarbeitung personenbezogener Daten richtet sich nach unserer{" "}
        <a href="/datenschutz" className="text-purple-700 hover:underline">
          Datenschutzerklärung
        </a>
        .
      </p>

      <h2 className="text-xl font-semibold mt-8">9. Kündigung und Datenlöschung</h2>
      <p>
        Der Nutzer kann sein Konto jederzeit über die Einstellungen löschen.
        Mit der Kontolöschung werden alle personenbezogenen Daten innerhalb
        von 30 Tagen unwiderruflich entfernt. Der Anbieter kann das Angebot
        jederzeit mit angemessener Frist einstellen.
      </p>

      <h2 className="text-xl font-semibold mt-8">10. Änderungen der AGB</h2>
      <p>
        Der Anbieter behält sich vor, diese AGB mit angemessener
        Vorankündigungsfrist zu ändern. Nutzer werden per E-Mail über
        wesentliche Änderungen informiert. Die weitere Nutzung nach Ablauf der
        Frist gilt als Zustimmung zur geänderten Fassung.
      </p>

      <h2 className="text-xl font-semibold mt-8">11. Anwendbares Recht und Gerichtsstand</h2>
      <p>
        Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts.
        Gerichtsstand für Streitigkeiten mit Kaufleuten oder juristischen
        Personen des öffentlichen Rechts ist Mannheim.
      </p>

      <p className="mt-8 text-sm text-gray-500">Stand: Juli 2026</p>
    </LegalLayout>
  );
};

export default AGBPage;
